import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  getOrderStatus,
  fetchPreorderOrderStatus,
} from "../../api/orders.api";
import "./payment-processing.css";
import { useCart } from "../../context/CartContext";

const PaymentProcessing = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isPreorderView = queryParams.get("type") === "preorder";
    const [status, setStatus] = useState("checking");
    const { clearCart } = useCart();

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                const res = await (
                    isPreorderView
                        ? fetchPreorderOrderStatus(orderId)
                        : getOrderStatus(orderId)
                );
                const paymentStatus = String(
                    res?.payment_status || res?.status || ""
                ).toLowerCase();

                if (paymentStatus === "paid") {
                    clearCart();
                    clearInterval(interval);
                    setStatus("success");

                    setTimeout(() => {
                        navigate(
                            `/order-confirmation/${orderId}${
                                isPreorderView ? "?type=preorder" : ""
                            }`
                        );
                    }, 1800);
                }

                if (paymentStatus === "failed") {
                    clearInterval(interval);
                    setStatus("failed");
                }

            } catch {
                clearInterval(interval);
                setStatus("failed");
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [orderId, navigate, clearCart, isPreorderView]);

    return (
        <div className="payment-wrapper">
            <div className="payment-card">

                {status === "checking" && (
                    <>
                        <div className="spinner"></div>
                        <h2>Confirming Your Payment</h2>
                        <p>
                            Please wait while we securely verify your transaction.
                            This usually takes a few seconds.
                        </p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <div className="icon success">✓</div>
                        <h2>Payment Successful</h2>
                        <p>
                            Your order has been confirmed successfully.
                            Redirecting you shortly...
                        </p>
                    </>
                )}

                {status === "failed" && (
                    <>
                        <div className="icon error">✕</div>
                        <h2>Payment Verification Failed</h2>
                        <p>
                            If the amount was deducted, it will be refunded automatically.
                            Please try again or contact support.
                        </p>
                        <button
                            className="primary-btn"
                            onClick={() => navigate("/cart")}
                        >
                            Return to Cart
                        </button>
                    </>
                )}

            </div>
        </div>
    );
};

export default PaymentProcessing;
